export const RESOLVED_PROMISE = new Promise(resolve => resolve())

export default function nextTick() {
  return RESOLVED_PROMISE
}
